"use client";

import { memo, useState } from "react";
import { ChevronDownIcon, ChevronUpIcon } from "lucide-react";
import { TooltipIconButton } from "./tooltip-icon-button";
import { useTranslation } from "react-i18next";

interface ReasoningMessagePartProps {
  text: string;
  parentId?: string;
}

const ReasoningMessagePart = memo<ReasoningMessagePartProps>(
  ({ text, parentId }) => {
    const { t } = useTranslation();
    const [isCollapsed, setIsCollapsed] = useState(true);

    const toggleCollapse = () => {
      setIsCollapsed(!isCollapsed);
    };

    if (parentId) {
      return (
        <div
          className="text-sm text-amber-800 dark:text-amber-200 italic"
          dangerouslySetInnerHTML={{ __html: text }}
        />
      );
    }

    return (
      <div className="mt-4 rounded-lg border border-amber-200/20 bg-amber-50/10 p-3 dark:border-amber-200/10 dark:bg-amber-950/20">
        <div className="flex items-center justify-between">
          <span className="text-sm font-medium text-amber-800 dark:text-amber-200">
            {t("chat.reasoning")}
          </span>
          <TooltipIconButton
            tooltip={isCollapsed ? t("chat.expand") : t("chat.collapse")}
            onClick={toggleCollapse}
            className="h-6 w-6"
          >
            {isCollapsed ? (
              <ChevronDownIcon className="h-4 w-4 text-amber-800 dark:text-amber-200" />
            ) : (
              <ChevronUpIcon className="h-4 w-4 text-amber-800 dark:text-amber-200" />
            )}
          </TooltipIconButton>
        </div>
        {!isCollapsed && (
          <div className="mt-2 space-y-2">
            <div
              className="text-sm text-amber-800 dark:text-amber-200 italic"
              dangerouslySetInnerHTML={{ __html: text }}
            />
          </div>
        )}
      </div>
    );
  },
);

ReasoningMessagePart.displayName = "ReasoningMessagePart";

export { ReasoningMessagePart }; 